import { create } from "zustand";

interface ClaimantFormState {
  claimantForm: {
    title: string;
    lastName: string;
    firstName: string;
    initials: string;
    gender: string;
    dateOfBirth: string;
    maritalStatus: string;
    nationality: string;
    countryOfBirth: string;
    countryOfResidence: string;
    beneficiaryEmployer: string;
    address: string;
    contactNumber: string;
    email: string;
    branchName: string;
    postalAddress: string;
    employerName: string;
    occupation: string;
    sourceOfFunds: string;
    identificationNumber: string;
    //claimantCellPhone: string;
    postalCode: string;
    networkProvider: string;
    relationship: string;
    agentOrBroker: string;
    identificationType: string;
  };
  setClaimantForm: (data: Partial<ClaimantFormState["claimantForm"]>) => void;
  resetClaimantForm: () => void;
}

export const useClaimantFormStore = create<ClaimantFormState>((set) => ({
  claimantForm: {
    title: "",
    lastName: "",
    firstName: "",
    initials: "",
    gender: "",
    dateOfBirth: "",
    maritalStatus: "",
    nationality: "",
    countryOfBirth: "",
    countryOfResidence: "",
    beneficiaryEmployer: "",
    address: "",
    contactNumber: "",
    email: "",
    branchName: "",
    postalAddress: "abc",
    employerName: "Bosch",
    occupation: "",
    sourceOfFunds: "",
    identificationNumber: "",
    //claimantCellPhone: "",
    postalCode: "",
    agentOrBroker: "",
    identificationType: "id",
    networkProvider: "",
    relationship: "",
  },

  setClaimantForm: (data) =>
    set((state) => ({
      claimantForm: {
        ...state.claimantForm,
        ...data,
      },
    })),
  resetClaimantForm: () =>
    set(() => ({
      claimantForm: {
        title: "",
        lastName: "",
        firstName: "",
        initials: "",
        gender: "",
        dateOfBirth: "",
        maritalStatus: "",
        nationality: "",
        countryOfBirth: "",
        countryOfResidence: "",
        beneficiaryEmployer: "",
        address: "",
        contactNumber: "",
        email: "",
        branchName: "",
        postalAddress: "abc",
        employerName: "Bosch",
        occupation: "",
        sourceOfFunds: "",
        identificationNumber: "",
        //claimantCellPhone: "",
        postalCode: "",
        agentOrBroker: "",
        identificationType: "id",
        networkProvider: "",
        relationship: "",
      },
    })),
}));
